const OrderActionTypes = {
    LOAD_FILE_IMPORT: 'order/load_file_import',
    LOAD_COLUMNS: 'order/load_columns',
    NEXT_STEP: 'order/next_step',
    PREV_STEP: 'order/prev_step',
    CANCEL_IMPORT: 'order/cancel_import',
    LOADING: 'order/loading',
    UPDATE_DATA_IMPORT: 'order/update_data_import',
  };
  
  export default OrderActionTypes;